import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@material-ui/core";
import React, { useState,useEffect } from "react";
import PageTitle from "../../../components/PageTitle/PageTitle";
import useStyles from "../../../themes/style.js";
import CerificateImage from "../../../images/certificate/badge.png";
import moment from "moment";
import axios from "axios";
import { Link } from "@material-ui/core";
import { useNotification } from "../../../hooks/useNotification.js";
import { IoClose } from "react-icons/io5";
import NoDataFound from "../../../components/NoDataFound/index.js";

function ProjectDetails() {
  const classes = useStyles();
  const handleNotificationCall = useNotification();
  const token = localStorage.getItem("token");
  const [projects,setProjects]=useState([]);

   useEffect(()=>{
    fetchProjectData();
      },[]);

      async function fetchProjectData(){
        try{
        const response = await axios.get(
         
          `${process.env.REACT_APP_SERVER}employee/viewMyProjects`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
          },
        );
  
        if(response.data.status){
          // handleNotificationCall("success", response.data.message);
          
          const data= response.data.data;
          setProjects(data);
          console.log(data);
        }
        else{
          handleNotificationCall("error", response.data.message)
        }
      }
      catch(error){
        console.log("Error Fetch Profile Data",error);
      }
  
  
      }

  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);

  const handleFeedbackModalOpen = () => {
    setFeedbackModalOpen(true);
  };

  const handleFeedbackModalClose = () => {
    setFeedbackModalOpen(false);
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Project Details" />
        </Grid>
      </Grid>
      {projects.length === 0 && <NoDataFound height="80vh" message="No Data Found"/>}
      <Grid container spacing={2}>
        {projects.map((project) => (
          <Grid item xs={12} sm={6} md={4} lg={4} key={project.id}>
            <Card className={classes.root} variant="outlined">
              <CardContent>
                {/* <Chip
                  style={{ background: "#FFF574" }}
                  color="#FFF574"
                  size="small"
                  label="Casual Leave"
                  icon={<MdOutlineTagFaces />}
                /> */}
                {/* <Chip
                  style={{ background: "#FF7D29", color: "#fff" }}
                  size="small"
                  label="Sick Leave"
                  icon={<MdOutlineSick color="#fff" />}
                /> */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h3>{project.hiringManager.recruiter=== null ? project.hiringManager.employee?.firstName +" "+ project.hiringManager.employee?.lastName : project.hiringManager.recruiter?.firstName +" "+ project.hiringManager.recruiter?.lastName }</h3>
                  <div
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      background: "#ccc",
                    }}
                  ></div>
                </div>

                <h2 color="textPrimary" style={{ marginTop: 0,fontSize: "14px" }}>
                 {project.projectName}
                </h2>

                {/* <Typography color="textPrimary" variant="body2" gutterBottom>
                  Apply Date:{" "}
                  <b> {moment(new Date("2000-06-02")).format("DD-MM-YYYY")}</b>
                </Typography>

                <Typography
                 color="textPrimary" variant="body2" gutterBottom>
                  Approval Date:{" "}
                  <b> {moment(new Date("2000-06-02")).format("DD-MM-YYYY")}</b>
                </Typography> */}
                <Typography
                  variant="body2"
                  component="p"
                  style={{
                    minHeight: "150px",
                    overflow: "scroll",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 6,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                 {project.projectDetails}
                </Typography>
              </CardContent>
              <CardActions
                style={{
                  padding: "0px 16px 16px",
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                {/* <Link
                  component="button"
                  variant="body2"
                  onClick={() => {
                    handleFeedbackModalOpen();
                  }}
                >
                  Read More
                </Link> */}
                <div style={{color:"#555"}}>{moment(project.createdAt).format("MMM Do YYYY")}</div>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* <Dialog
        open={feedbackModalOpen}
        fullWidth
        maxWidth="xs"
        onClose={handleFeedbackModalClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent style={{ padding: "20px 30px" }}> */}
          {/* <Chip
                  style={{ background: "#FFF574" }}
                  color="#FFF574"
                  size="small"
                  label="Casual Leave"
                  icon={<MdOutlineTagFaces />}
                /> */}
          {/* <Chip
                  style={{ background: "#FF7D29", color: "#fff" }}
                  size="small"
                  label="Sick Leave"
                  icon={<MdOutlineSick color="#fff" />}
                /> */}
          {/* <Box style={{ display: "flex", justifyContent: "end" }}>
            <div
              onClick={handleFeedbackModalClose}
              style={{ cursor: "pointer" }}
            >
              <IoClose size={22} />
            </div>
          </Box>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3>Hiring Manager</h3>
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: "#ccc",
              }}
            ></div>
          </div>

          <h2 color="textPrimary" style={{ marginTop: 0 }}>
            Project Name
          </h2> */}

          {/* <Typography color="textPrimary" variant="body2" gutterBottom>
                  Apply Date:{" "}
                  <b> {moment(new Date("2000-06-02")).format("DD-MM-YYYY")}</b>
                </Typography>

                <Typography
                 color="textPrimary" variant="body2" gutterBottom>
                  Approval Date:{" "}
                  <b> {moment(new Date("2000-06-02")).format("DD-MM-YYYY")}</b>
                </Typography> */}
          {/* <Typography variant="body1" component="p">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged.
            <br />
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged.
          </Typography>
        </DialogContent>
      </Dialog> */}
    </div>
  );
}

export default ProjectDetails;
